import { useState } from "react";
import { Grid, Box, Typography, IconButton, Button } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useScopeOfWork } from "../../context/ScopeOfWorkContext";
import { useModals } from "../../../../../../../context/ModalContext";
import { useOtherAreasPagination } from "./hooks/useOtherAreasQuery";
import { QueryState } from "../../../../query-states/GlobalQueryState";
import { SASButtonStyles } from "../../../../../../ui/styles/inputStyles";
import { OtherAreasCardSelectable } from "./OtherAreasCardSelectable";

export const OtherAreas = () => {
  const { state, dispatch } = useScopeOfWork();
  const { closeByKey } = useModals();

  const category = state.category?.name;
  const typeOfService = state.service?.name;

  const selectedMainAreas = state.areas ?? [];
  const selectedOtherAreas = state.otherAreas ?? [];

  const [tempSelectedAreas, setTempSelectedAreas] = useState(selectedOtherAreas);

  const { items, isLoading, isError, goNextPage, goPrevPage, page, totalPages } =
    useOtherAreasPagination({ category, typeOfService });

  const extraAreas = (items ?? []).filter(
    (area: any) => !selectedMainAreas.some((a: any) => a.uid === area.uid)
  );

  const handleToggle = (area: any) => {
    setTempSelectedAreas((prev) => {
      const exists = prev.find((x: any) => x.uid === area.uid);
      return exists ? prev.filter((x: any) => x.uid !== area.uid) : [...prev, area];
    });
  };

  const handleConfirm = () => {
    dispatch({ type: "SET_OTHER_AREAS", payload: tempSelectedAreas });
    closeByKey("Other-Areas-Selector");
  };

  if (isLoading || isError) {
    return <QueryState serviceName="Other Areas" isLoading={isLoading} isError={isError} />;
  }

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "var(--fx-surface-base, #FFFFFF)", mb: 2 }}>
        <IconButton onClick={goPrevPage} disabled={page === 1}>
          <ChevronLeft fontSize="large" />
        </IconButton>

        <Typography fontWeight={700}>
          Page {page} / {totalPages}
        </Typography>

        <IconButton onClick={goNextPage} disabled={page === totalPages}>
          <ChevronRight fontSize="large" />
        </IconButton>
      </Box>

      <Grid container spacing={2} sx={{ flexGrow: 1, overflowY: "auto" }}>
        {extraAreas?.map((area: any) => (
          <Grid item xs={6} sm={4} md={3} key={area.uid}>
            <OtherAreasCardSelectable
              area={area}
              selected={!!tempSelectedAreas.find((x: any) => x.uid === area.uid)}
              onToggle={() => handleToggle(area)}
            />
          </Grid>
        ))}
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pt: 2, borderTop: "1px solid var(--fx-surface-border, #E2E8F0)", mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {tempSelectedAreas.length} area(s) selected
        </Typography>

        <Box sx={{ display: "flex", gap: 1, p: 2 }}>
          <Button
            onClick={() => closeByKey("Other-Areas-Selector")}
            variant="outlined"
            sx={{ textTransform: "none", borderColor: "var(--fx-surface-borderstrong, #CBD5E1)", color: "var(--fx-surface-textsecondary, #64748B)" }}
          >
            Cancel
          </Button>

          <Button onClick={handleConfirm} sx={{ ...SASButtonStyles }}>
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
